import React, {
  ChangeEvent,
  DragEvent,
  FC,
  useEffect,
  useRef,
  useState
} from 'react';
import {
  ItemRenderProps,
  SortableItem,
  SortableItemProps,
  SortableList
} from '@thaddeusjiang/react-sortable-list';
import {
  ReOrderableItem,
  ReOrderableList,
  ReOrderableListGroup
} from 'react-reorderable-list-fork';
import { v4 as uuidv4 } from 'uuid';
import MediaCard from './MediaCard';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {
  Button,
  Dropdown,
  Form,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';
import axios from 'axios';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {
  PLATFORM_COLORS,
  PLATFORM_DISPLAY_NAME_KEYS,
  PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL,
  PLATFORM_ICONS
} from '../../../../config/icons';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import {
  getVideoThumbnail,
  isMediaVideo,
  isMediaPdf,
  generateFirebaseUploadUrl,
  isMediaImage
} from '../../../../redux/slices/lomavisCreator/utils';
import {
  addDraggedFiles,
  addMediaFiles,
  addMediaUploadingFiles,
  clearEditedMediafile,
  clearUnuploadedFiles,
  deleteALoadingfile,
  removeDraggedFiles,
  reorderMediaFiles,
  setModalUiContent,
  setPostDataAttribute,
  setScheduleModalToggle,
  setSliceAttribute,
  updateAssetUploadingState,
  updateCancelToken,
  updateMultiImageEditorCloseState
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import VideoThumbnail from 'react-video-thumbnail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpFromBracket,
  faPhotoFilm,
  faCirclePlus,
  faCrop
} from '@fortawesome/pro-duotone-svg-icons';
import Modal from '../../../modals';
import ModalBody from '../../../modals/modalBody';
import SchedulingModal from '../Scheduling';
import RecurrenceConfirmation from '../../cards/recurrenceConfirmation';
import toast from 'react-hot-toast';
import PlanningConfirmation from '../../cards/planningConfirmation';
import ThumbnailPicker from '../thumbnailPicker';
import ThumbnailPreviewCard from '../../cards/thumbnailPreviewCard';
import { validateAllUpload, validateUpload } from '../../config/postValidator';
import {
  ALL,
  MAIN_COLOR_CODES,
  PRIMARY_DARK,
  UPLOAD_TYPES,
  UPLOAD_TYPE_POST_MEDIA
} from '../../../../config/constants';
import {
  compressImage,
  convertHeicToJpeg,
  createMockFile,
  determineImageDimensionsFromURL,
  getImageDimensions,
  isHeicLikeExtension,
  isHeicLikeFile,
  isHeicLikeMimeType,
  getObjectAsFile,
  getPdfDimensions,
  getVideoDimensions
} from '../../utils/helpers';
import MP4Box from 'mp4box';
import { duration } from 'moment';
import MultiImageModifier from '../MultiImageAutoModifier';
import EditorConfirmation from '../../cards/editorExitConfirmation';
import {
  CLOUD_BROWSER_DOWNLOAD_THRESHOLD_BYTES,
  EXTERNAL,
  MAX_MEDIA_FILES,
  MEDIA_UPLOAD_ALL_EXTENSIONS,
  MEDIA_UPLOAD_ALL_MIME_TYPES,
  MEDIA_UPLOAD_IMAGE_ONLY_EXTENSIONS,
  MEDIA_UPLOAD_IMAGE_ONLY_MIME_TYPES,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_VIDEO,
  VIDEO
} from '../../config/constants';
import VideoModifier from '../MultiImageAutoModifier/videoModifier';
import CreatorPlatformTitle from '../commonElements/creatorPlatformTitle';
import TempMediaCard from './temporaryMediaCard';
import MediaLibraryPopup from './MediaLibraryPopup';
import OtherOptionsDropdown from './otherOptionsDropdown';
import { getCloudPickerErrorTranslationKey } from './cloudPickerProviders';
import type { CloudPickerFile } from './cloudPickers/types';
import { uploadCloudFileViaBackend } from './cloudPickerBackendUpload';
import { inferMimeFromFilename } from './cloudPickerFileUtils';
import CloudExportProgressModal, {
  CloudExportItem
} from './CloudExportProgressModal';
import CloudServerTransferModal from './CloudServerTransferModal';
import { handleMediaLibraryFileChange } from './utils';
import ThumbnailDropDown from './thumbnailDropdown';
import { ConfirmationModal } from '../confirmationModal';
import { POST_TYPE_TEMPLATE } from '../../config/platformFeatures';
import ToolTipWithTrigger from '../commonElements/tooltip';
import type { OverlayTemplateDetailDto } from '../../../../api/overlayTemplates';
import {
  getOverlayTemplateEligibleMedia,
  hasOverlayBeenPlaced,
  OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR
} from '../../config/overlayTemplateCreator';
import localForage from 'localforage';

interface MediaUploadAreaProps {
  platform: string;
  sortableListRef: any;
  templateMode?: boolean;
  overlayTemplate?: OverlayTemplateDetailDto | null;
}

const MediaUploadBox: FC<MediaUploadAreaProps> = ({
  platform,
  sortableListRef,
  templateMode = false,
  overlayTemplate = null
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch();

  const { t } = useTranslate();
  const postData = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[platform]
  );

  const lomavisCreator = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  const allPostData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData
  );

  const postDataMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[platform]?.media
  );
  const time = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.time
  );
  const recurrence = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.recurrence_as_str
  );
  const draggedFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator?.postData?.[platform]?.draggedMediaFiles
  );
  const mediaLibraryFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator?.postData?.[platform]?.mediaLibraryFiles
  );
  const loadedMediaFiles = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator?.loadedMediaFiles
  );
  const layeredImageThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[platform]?.layeredImageThumbnail?.url
  );
  const typeKey = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postTypeSelected[platform]
  );
  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );
  const typeKeyAll = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postTypeSelected
  );
  const location_uuid = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.locationUuid
  );
  const cloud_uuid = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.cloudUuid
  );
  const multiEditorChanged = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.allowMultiImageEditor
  );
  const { uploadCancelToken, general_post_type } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );
  const postIsOverlay = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.overlay_enabled
  );
  const overlay_enabled = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.general_post_type === POST_TYPE_TEMPLATE ||
      postIsOverlay
  );

  const allowedMediaMimeTypes = overlay_enabled
    ? MEDIA_UPLOAD_IMAGE_ONLY_MIME_TYPES
    : MEDIA_UPLOAD_ALL_MIME_TYPES;
  const allowedMediaExtensions = overlay_enabled
    ? MEDIA_UPLOAD_IMAGE_ONLY_EXTENSIONS
    : MEDIA_UPLOAD_ALL_EXTENSIONS;
  const fileInputAcceptString = allowedMediaExtensions.join(', ');

  const [uploadInProcess, setUploadInProcess] = useState(false);
  const [showTemplateImageOnlyModal, setShowTemplateImageOnlyModal] =
    useState(false);
  const [pendingTemplateDragFiles, setPendingTemplateDragFiles] = useState<
    File[]
  >([]);
  const [leavingTemplateMode, setLeavingTemplateMode] = useState(false);
  const [uploadProcessInPercent, setuploadProcessInPercent] = useState(0);

  const [items, setItems] = useState<SortableItemProps[]>([]);
  const [cropMode, setCropMode] = useState(true);
  const [totalUploadCount, setTotalUploadCount] = useState(0);
  const [currentUploadCount, setCurrentUploadCount] = useState(0);
  const [videoThumbnail, setVideoThumbnail] = useState('');
  const [isThumbnailValid, setIsThumbnailValid] = useState(false);

  useEffect(() => {
    if (postData?.media[0]?.media_type == VIDEO) {
      setIsThumbnailValid(true);
    } else {
      setIsThumbnailValid(false);
    }
  }, [postData?.media]);

  useEffect(() => {
    if (Array.isArray(postData.media)) {
      setItems([
        ...postData.media.map((file: any) => {
          return {
            id: `${file.id}`,
            uuid: file.uuid,
            name: file.name,
            preview_image: file.preview_image,
            orientation: file.orientation,
            media_type: file.media_type,
            video_duration: file.video_duration,
            uploadPreset: file.uploadPreset,
            file: file.file,
            file_type: file.file_type,
            uploaded: file.uploaded,
            isUploading: file.isUploading,
            newUpload: file?.newUpload,
            assetBlob: file.assetBlob,
            source_media_uuid: file.source_media_uuid,
            editorUpdateState: file?.editorUpdateState,
            previewImageURL: file.previewImageURL,
            thumbnail_image: file.thumbnail_image,
            original_asset: file.original_asset,
            api_url: file?.api_url,
            saved_in_media_library: file?.saved_in_media_library
          };
        }),

        ...postData.mediaUploading?.map((file: any) => {
          return {
            id: `${file.id}`,
            uuid: file.uuid,
            preview_image: file.preview_image,

            media_type: file.media_type,

            file: file.file,
            file_type: file.file_type,
            isUploading: file.isUploading,
            assetBlob: file.assetBlob
          };
        })
      ]);
    }
  }, [postData.media, postData.mediaUploading, allPostData]);

  const startUpload = () => {
    setuploadProcessInPercent(0);
    setUploadInProcess(true);
  };

  const handleUploadClick = async () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  };

  const isTemplateImageFile = (file: any) =>
    isMediaImage(file) ||
    isHeicLikeFile(file) ||
    String(file?.media_type ?? '').toLowerCase() === MEDIA_TYPE_IMAGE ||
    String(file?.mimeType ?? '').startsWith('image/') ||
    String(file?.file_type ?? '').startsWith('image/');

  const filterTemplateUploadFiles = (files: any[]) => {
    if (!templateMode || !OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.imageUploadsOnly) {
      return files;
    }

    const imageFiles = files.filter(isTemplateImageFile);
    if (imageFiles.length !== files.length) {
      setShowTemplateImageOnlyModal(true);
    }
    return imageFiles;
  };

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }

    const fileArray = filterTemplateUploadFiles(Array.from(e.target.files));
    if (fileArray.length === 0) {
      return;
    }

    if (
      Array.isArray(postData.media) &&
      postData.media?.length + postData.mediaUploading?.length <
        MAX_MEDIA_FILES
    ) {
      const currentCount =
        MAX_MEDIA_FILES -
        (postData.media?.length + postData.mediaUploading?.length);
      currentCount > -1
        ? uploadAssets(fileArray.slice(0, currentCount))
        : toast.error(`${t('lomavisCreator.errors.max_limit_reached')}`, {
            duration: 4000,
            position: 'top-right'
          });
    } else {
      toast.error(`${t('lomavisCreator.errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });

      console.error(
        `Maximum limit (${MAX_MEDIA_FILES}) reached!`,
        postData.media?.length
      );
    }
  };

  const handleDraggedFileChange = async (files: any[]) => {
    if (!files) {
      return;
    }

    // TODO: Check if file upload is ok

    // 🚩 do the file upload here normally...

    const fileArray = filterTemplateUploadFiles(Array.from(files));
    if (fileArray.length === 0) {
      dispatch(removeDraggedFiles({ platform: platform }));
      return;
    }
    await uploadAssets(fileArray);
    dispatch(removeDraggedFiles({ platform: platform }));
  };

  const continueWithoutTemplate = async () => {
    setLeavingTemplateMode(true);
    try {
      const cacheKey = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;
      await localForage.removeItem(cacheKey);
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.delete('overlay_template_uuid');
      window.location.assign(nextUrl.toString());
    } finally {
      setLeavingTemplateMode(false);
    }
  };

  const uploadAssets = async (fileArray) => {
    const prevUploadedFiles = postDataMediaFiles.map((item) =>
      item?.file ? item?.file : getObjectAsFile(item)
    );

    const total_file_array = [...prevUploadedFiles, ...fileArray];

    const is_valid =
      platform === ALL
        ? await validateAllUpload(
            platform,
            typeKeyAll,
            total_file_array,
            t,
            dispatch,
            platformEnabled
          )
        : await validateUpload(platform, typeKey, total_file_array, t);

    if (!is_valid) {
      inputRef.current.value = '';
      return;
    }

    setCurrentUploadCount(0);
    setTotalUploadCount(fileArray.length);
    await dispatch(
      updateAssetUploadingState({
        state: true
      })
    );

    startUpload();
    const filesWithPreview = await Promise.all(
      fileArray.map(async (file) => {
        const temporaryUuid = uuidv4();
        try {
          let originalFile = file;

          dispatch(
            addMediaUploadingFiles({
              platform: platform,
              files: [
                {
                  id: temporaryUuid,
                  uuid: temporaryUuid,
                  name: `${file.name}`,
                  file: file,
                  preview_image: isMediaVideo(file)
                    ? await getVideoThumbnail(file)
                    : URL.createObjectURL(file),
                  media_type: isMediaImage(file)
                    ? 'image'
                    : isMediaVideo(file)
                    ? 'video'
                    : isMediaPdf(file)
                    ? 'doc'
                    : 'image',
                  file_type: file.type,
                  assetBlob: URL.createObjectURL(file),
                  isUploading: true
                }
              ]
            })
          );

          if (isMediaImage(file)) {
            // Normalize image bytes first so mislabeled HEIC/HEIF files
            // (e.g. .jpeg/.png extension with HEIC payload) can still be decoded.
            file = await convertHeicToJpeg(file);
            const compressedFile = await compressImage(file);
            file = compressedFile;
          }

          let preview_image = URL.createObjectURL(file);
          let assetBlob = URL.createObjectURL(file);
          const file_type = file.type;
          const fileSizeInBytes = file.size;
          let media_type = 'image';
          let video_duration = null;
          let uploadPreset;
          let source_media_uuid = null;
          let uploaded = false;

          const orientation = await getFileOrientation(file).catch((error) => {
            console.error('Error reading file orientation:', error);
            throw error;
          });

          let dimensions;
          if (isMediaImage(file)) {
            dimensions = await determineImageDimensionsFromURL(
              preview_image
            ).catch((error) => {
              console.error('Error getting image dimensions:', error);
              throw error;
            });
            uploadPreset = await generateFirebaseUploadUrl(
              {
                content_type: file_type,
                filesize_in_bytes: fileSizeInBytes,
                filename: file.name,
                location_uuid: location_uuid,
                cloud_uuid: cloud_uuid,
                width: dimensions?.width,
                height: dimensions?.height,
                upload_type: UPLOAD_TYPE_POST_MEDIA
              },
              {},
              () => {
                console.error('Error generating upload URL');
              }
            );
          }

          if (isMediaVideo(file)) {
            dimensions = await getVideoDimensions(file);

            media_type = 'video';
            try {
              video_duration = await getVideoDuration(file);
            } catch (error) {
              console.error('Failed to get video duration:', error);
            }

            preview_image = await getVideoThumbnail(file);
            uploadPreset = await generateFirebaseUploadUrl(
              {
                content_type: file_type,
                filesize_in_bytes: fileSizeInBytes,
                filename: file.name,
                location_uuid: location_uuid,
                cloud_uuid: cloud_uuid,
                width: dimensions?.width,
                height: dimensions?.height,
                duration_in_ms: video_duration,
                upload_type: UPLOAD_TYPE_POST_MEDIA
              },
              {},
              () => console.log('error here')
            );
          }

          if (isMediaPdf(file)) {
            media_type = 'doc';
            dimensions = await getPdfDimensions(file);
            uploadPreset = await generateFirebaseUploadUrl(
              {
                content_type: file_type,
                filesize_in_bytes: fileSizeInBytes,
                filename: file.name,
                location_uuid: location_uuid,
                cloud_uuid: cloud_uuid,
                width: dimensions?.width,
                height: dimensions?.height,
                upload_type: UPLOAD_TYPE_POST_MEDIA
              },
              {},
              () => console.log('error here')
            );
          }

          return {
            file,
            preview_image,
            media_type,
            video_duration,
            orientation,
            fileSizeInBytes,
            uploadPreset,
            file_type,
            assetBlob,
            source_media_uuid,
            uploaded,
            dimensions,
            temporaryUuid
          };
        } catch (error) {
          toast.error(`${t('lomavisCreator.fileUpload.fail')}`, {
            duration: 4000,
            position: 'top-right'
          });
          dispatch(
            deleteALoadingfile({
              platform: platform,
              fileID: temporaryUuid
            })
          );
        }
      })
    );

    if (postData) {
      dispatch(
        addMediaFiles({
          platform,
          files: filesWithPreview
            .map((file) => {
              dispatch(
                deleteALoadingfile({
                  platform: platform,
                  fileID: file?.temporaryUuid
                })
              );
              if (file?.uploadPreset || file?.uploaded) {
                return {
                  id: `${file.uploadPreset?.uuid}`,
                  uuid: file.uploadPreset?.uuid,
                  name: `${file.file.name}`,
                  file: file.file,
                  preview_image: file.preview_image,
                  orientation: file.orientation,
                  media_type: file.media_type,
                  video_duration: file.video_duration,
                  file_size: file.fileSizeInBytes,
                  width: file.dimensions?.width,
                  height: file.dimensions?.height,
                  uploadPreset: file.uploadPreset,
                  file_type: file.file_type,
                  assetBlob: file.assetBlob,
                  source_media_uuid: file.source_media_uuid,
                  uploaded: file.uploaded,
                  isUploading: true,
                  editorUpdateState: true,
                  previewImageURL:
                    file.uploadPreset?.uploaded_object_data.preview_image_url,
                  thumbnail_image: file.uploadPreset?.thumbnail_url,
                  original_asset:
                    file.uploadPreset?.uploaded_object_data.original_asset,
                  media_alt_description:
                    file.uploadPreset?.uploaded_object_data
                      ?.media_alt_description,
                  api_url: file.uploadPreset?.uploaded_object_data?.api_url,
                  saved_in_media_library: false
                };
              } else {
                return null;
              }
            })
            .filter((file) => file !== null)
        })
      );
    }

    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const getVideoDuration = async (file: File): Promise<number | null> => {
    return new Promise((resolve, reject) => {
      // Check if the file is an MP4
      if (file.type === 'video/mp4') {
        // Handle MP4 files using mp4box.js
        const mp4boxFile = MP4Box.createFile();
        const fileReader = new FileReader();

        fileReader.onload = (e) => {
          const arrayBuffer = e.target?.result as ArrayBuffer;

          // Cast the arrayBuffer to the expected format for mp4box.js
          const bufferWithFileStart = Object.assign(arrayBuffer, {
            fileStart: 0
          });

          mp4boxFile.onError = (error) => {
            reject(`Error parsing MP4 file: ${error}`);
          };

          mp4boxFile.onReady = (info) => {
            const durationInSeconds = info.duration / info.timescale;
            resolve(Math.round(durationInSeconds * 1000)); // Convert to milliseconds
          };

          mp4boxFile.appendBuffer(bufferWithFileStart);
          mp4boxFile.flush();
        };

        fileReader.readAsArrayBuffer(file);
      } else {
        // Fallback for non-MP4 video files
        const video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src);
          resolve(Math.round(video.duration * 1000)); // Convert to milliseconds
        };

        video.onerror = () => {
          reject('Failed to load video');
        };

        video.src = URL.createObjectURL(file);
      }
    });
  };
  function getFileOrientation(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          let orientation;
          if (img.width > 0 && img.height > 0) {
            if (img.width > img.height) {
              orientation = 'landscape';
            } else if (img.height > img.width) {
              orientation = 'portrait';
            } else {
              orientation = 'square';
            }
            resolve(orientation);
          } else {
            // Image dimensions are 0, might not be an image
            resolve(null);
          }
        };
        img.onerror = () => {
          // Error loading image, might not be an image
          resolve(null);
        };
        img.src = event.target.result as string; // Explicit cast to string
      };
      reader.onerror = () => {
        // Error reading file, can't determine orientation
        resolve(null);
      };

      if (file.type.startsWith('image')) {
        reader.readAsDataURL(file);
      } else if (file.type.startsWith('video')) {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = () => {
          const aspectRatio = video.videoWidth / video.videoHeight;

          let orientation;
          if (video.videoWidth > 0 && video.videoHeight > 0) {
            if (aspectRatio > 1) {
              orientation = 'landscape';
            } else if (aspectRatio < 1) {
              orientation = 'portrait';
            } else {
              orientation = 'square';
            }
            resolve(orientation);
          } else {
            // Image dimensions are 0, might not be an image
            resolve(null);
          }
        };
        video.onerror = () => {
          // Error loading video, can't determine aspect ratio
          resolve(null);
        };
        video.src = URL.createObjectURL(file);
      } else {
        // Unsupported file type, can't determine orientation
        resolve(null);
      }
    });
  }
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  useEffect(() => {
    if (draggedFiles.length > 0) {
      handleDraggedFileChange(draggedFiles);
    }
  }, [draggedFiles]);
  useEffect(() => {
    if (mediaLibraryFiles.length > 0) {
      const imageFiles = filterTemplateUploadFiles(mediaLibraryFiles);
      handleMediaLibraryFileChange(
        imageFiles,
        dispatch,
        t,
        postDataMediaFiles,
        platform,
        typeKey,
        typeKeyAll,
        platformEnabled
      );
    }
  }, [
    dispatch,
    mediaLibraryFiles,
    platform,
    platformEnabled,
    postDataMediaFiles,
    t,
    templateMode,
    typeKey,
    typeKeyAll
  ]);

  useEffect(() => {
    if (loadedMediaFiles.length > 0) {
      const imageFiles = filterTemplateUploadFiles(loadedMediaFiles);
      handleMediaLibraryFileChange(
        imageFiles,
        dispatch,
        t,
        postDataMediaFiles,
        platform,
        typeKey,
        typeKeyAll,
        platformEnabled,
        false
      );
    }
  }, [loadedMediaFiles]);

  const {
    ui: { scheduleModalToggle }
  } = useSelector((state: lomavisCreatorRootState) => state.lomavisCreator);
  const [thumbnailToggle, setThumbnailToggle] = useState(false);
  const [autoImageModToggle, setAutoImageModToggle] = useState(false);
  const templateMediaEditorOpen = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.modalStates.templateMediaEditor.toggle
  );

  useEffect(() => {
    if (
      !templateMode ||
      !OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.requireTemplateSaveBeforeExit ||
      !overlayTemplate ||
      templateMediaEditorOpen
    )
      return;
    if (postDataMediaFiles?.some((item) => item.isUploading)) return;
    const pendingTemplateMedia =
      getOverlayTemplateEligibleMedia(postDataMediaFiles);
    if (pendingTemplateMedia.length) {
      dispatch(
        setModalUiContent({
          modal: 'templateMediaEditor',
          attribute: 'toggle',
          value: true
        })
      );
    }
  }, [
    dispatch,
    overlayTemplate,
    postDataMediaFiles,
    templateMediaEditorOpen,
    templateMode
  ]);

  // The overlay opens for one upload only, so the suppression that belongs to
  // the hand-off is asked per upload rather than for the whole mode. It cannot
  // ask "is this the eligible one", because that needs a finished upload and
  // the question is already being asked while the first file is still going
  // up — which handed the first image to the ordinary editor instead. Asking
  // whether the overlay is still to come holds from the first moment.
  const overlayStillToCome = !hasOverlayBeenPlaced(postDataMediaFiles);

  const [show, setShow] = useState(false);
  const [showEditorConfirmation, setShowEditorConfirmation] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const buttonRef = useRef(null);

  const fullEditorImage = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[platform].fullEditorImage
  );
  const layeredThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform]?.layeredImageThumbnail
  );

  const cancelRequest = async () => {
    uploadCancelToken.cancel('Operation canceled by the user.');

    dispatch(
      clearUnuploadedFiles({
        platform: platform
      })
    );
    dispatch(
      updateAssetUploadingState({
        state: false
      })
    );

    setTimeout(() => {
      dispatch(
        updateCancelToken({
          token: null
        })
      );
    }, 2000);
  };

  const [draggedItems, setDraggedItems] = useState([]);
  const [dragEnabled, setDragEnabled] = useState(false);
  const [cloudImportInProgress, setCloudImportInProgress] = useState(false);
  const [cloudExportItems, setCloudExportItems] = useState<CloudExportItem[]>(
    []
  );
  const [serverTransferFiles, setServerTransferFiles] = useState<string[]>([]);
  const [serverTransferBytes, setServerTransferBytes] = useState(0);
  const serverTransferControllerRef = useRef<AbortController | null>(null);

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setDragEnabled(false);

    const files = Array.from(event.dataTransfer.files);
    const hasUnsupportedTemplateFile =
      templateMode &&
      OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.imageUploadsOnly &&
      files.some((file) => !isTemplateImageFile(file));

    if (hasUnsupportedTemplateFile) {
      setPendingTemplateDragFiles(
        files.filter(isTemplateImageFile).filter(
          (file) =>
            allowedMediaMimeTypes.includes(file.type) || isHeicLikeFile(file)
        )
      );
      setShowTemplateImageOnlyModal(true);
      return;
    }

    const templateSafeFiles = filterTemplateUploadFiles(files);
    const filteredFiles = templateSafeFiles.filter(
      (file) =>
        allowedMediaMimeTypes.includes(file.type) || isHeicLikeFile(file)
    );

    queueDroppedFiles(filteredFiles);
  };

  const handleDragUpload = (filteredFiles: any[]) => {
    dispatch(
      addDraggedFiles({
        platform: platform,
        files: filteredFiles
      })
    );
  };

  const queueDroppedFiles = (files: File[]) => {
    if (files.length === 0) return;
    if (
      !Array.isArray(postData.media) ||
      postData.media.length + draggedItems.length + files.length >
        MAX_MEDIA_FILES
    ) {
      toast.error(`${t('errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });
      return;
    }

    handleDragUpload(files);
    setDraggedItems((currentItems) => [
      ...currentItems,
      ...files.filter((file) => !currentItems.includes(file))
    ]);
  };

  const confirmTemplateDraggedFiles = () => {
    if (pendingTemplateDragFiles.length > 0) {
      queueDroppedFiles(pendingTemplateDragFiles);
    }
    setPendingTemplateDragFiles([]);
    setShowTemplateImageOnlyModal(false);
  };

  const handleCancelServerTransfer = () => {
    serverTransferControllerRef.current?.abort();
    serverTransferControllerRef.current = null;
    setServerTransferFiles([]);
    setServerTransferBytes(0);
  };

  const handleCloudProviderUpload = async (files: CloudPickerFile[]) => {
    if (!Array.isArray(files) || files.length === 0) {
      return;
    }

    const currentMediaCount =
      (postData.media?.length || 0) + (postData.mediaUploading?.length || 0);
    if (currentMediaCount >= MAX_MEDIA_FILES) {
      toast.error(`${t('lomavisCreator.errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });
      return;
    }

    const availableSlots = MAX_MEDIA_FILES - currentMediaCount;
    const filesWithinLimit = files.slice(0, availableSlots);
    const filesToUpload = filterTemplateUploadFiles(filesWithinLimit);

    if (filesWithinLimit.length < files.length) {
      toast.error(`${t('lomavisCreator.errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });
    }

    // Resolve a valid mime type for every picked file. Picker metadata first,
    // then filename inference. Files we can't classify (extension not in our
    // allow-list, no mimeType from picker) get rejected up front so we never
    // hand `application/octet-stream` or undefined to the validator/backend.
    const validPickedFiles: CloudPickerFile[] = [];
    const resolvedMimes: string[] = [];
    let unsupportedCount = 0;
    filesToUpload.forEach((file) => {
      const resolvedMime =
        file.mimeType || inferMimeFromFilename(file.name);
      if (!resolvedMime) {
        unsupportedCount += 1;
        return;
      }
      validPickedFiles.push(file);
      resolvedMimes.push(resolvedMime);
    });

    if (unsupportedCount > 0) {
      toast.error(`${t('lomavisCreator.error.invalid_file_type')}`, {
        duration: 4000,
        position: 'top-right'
      });
    }

    if (validPickedFiles.length === 0) {
      return;
    }

    // Same platform-disable check the local upload / media library uses.
    // Build mock File-like objects from picker metadata so the validator can
    // compute media type / size constraints without the actual bytes.
    const mockPickedFiles = validPickedFiles.map((file, index) =>
      createMockFile({
        original_filename: file.name,
        file_type: resolvedMimes[index],
        file_size: file.size,
        original_asset: null,
        video_audio_channels: null,
        pdf_page_count: null
      })
    );
    const prevUploadedFiles = (postDataMediaFiles || []).map((item) =>
      item?.file ? item.file : getObjectAsFile(item)
    );
    const validationFiles = [...prevUploadedFiles, ...mockPickedFiles];

    const isValid =
      platform === ALL
        ? await validateAllUpload(
            platform,
            typeKeyAll,
            validationFiles,
            t,
            dispatch,
            platformEnabled
          )
        : await validateUpload(platform, typeKey, validationFiles, t);

    if (!isValid) {
      return;
    }

    // Files small enough to comfortably round-trip through the browser go
    // through the regular client pipeline (HEIC/compression/dimensions). Larger
    // files are ingested server-side via media_download_url so we don't burn
    // the user's bandwidth.
    //
    // HEIC files always use the browser path regardless of size because they
    // need client-side conversion to JPEG — the server-side ingestion endpoint
    // doesn't run heicTo.
    const smallFiles: Array<{ file: CloudPickerFile; id: string }> = [];
    const largeFiles: CloudPickerFile[] = [];

    validPickedFiles.forEach((file) => {
      const canBrowserDownload = typeof file.toBrowserFile === 'function';
      const isHeic =
        isHeicLikeMimeType(file.mimeType || '') ||
        isHeicLikeExtension(file.name || '');
      const usesBrowserDownload =
        canBrowserDownload &&
        (isHeic ||
          (typeof file.size === 'number' &&
            file.size < CLOUD_BROWSER_DOWNLOAD_THRESHOLD_BYTES));
      if (usesBrowserDownload) {
        smallFiles.push({ file, id: uuidv4() });
      } else {
        largeFiles.push(file);
      }
    });

    setCloudImportInProgress(true);
    try {
      const failedImportTranslationKeys = new Set<string>();

      // -------- Small files: browser download with progress + uploadAssets --------
      if (smallFiles.length > 0) {
        setCloudExportItems(
          smallFiles.map(({ file, id }) => ({
            id,
            name: file.name || file.provider,
            loaded: 0,
            total: file.size,
            status: 'in_progress' as const
          }))
        );

        const downloaded = await Promise.all(
          smallFiles.map(async ({ file, id }) => {
            try {
              const browserFile = await file.toBrowserFile!((loaded, total) => {
                setCloudExportItems((prev) =>
                  prev.map((entry) =>
                    entry.id === id
                      ? { ...entry, loaded, total: total ?? entry.total }
                      : entry
                  )
                );
              });
              setCloudExportItems((prev) =>
                prev.map((entry) =>
                  entry.id === id
                    ? {
                        ...entry,
                        loaded: browserFile.size,
                        total: browserFile.size,
                        status: 'done' as const
                      }
                    : entry
                )
              );
              return browserFile;
            } catch (error) {
              console.error(
                `Failed to download ${file.provider} media:`,
                error
              );
              failedImportTranslationKeys.add(
                getCloudPickerErrorTranslationKey(file.provider, error)
              );
              setCloudExportItems((prev) =>
                prev.map((entry) =>
                  entry.id === id
                    ? { ...entry, status: 'failed' as const }
                    : entry
                )
              );
              return null;
            }
          })
        );

        // Keep the modal visible briefly so the user sees the completed bars.
        await new Promise<void>((resolve) => setTimeout(resolve, 400));
        setCloudExportItems([]);

        const ready = downloaded.filter((item): item is File => item !== null);
        if (ready.length > 0) {
          await uploadAssets(ready);
        }
      }

      // -------- Large files: server-side ingestion --------
      const uploadedLargeFiles: any[] = [];
      if (largeFiles.length > 0) {
        // These files are too large to round-trip through the browser, so the
        // backend pulls them straight from the provider. Let the user know why
        // it takes a moment (there's no client-side progress to show) and let
        // them cancel the in-flight server-to-server transfer.
        const controller = new AbortController();
        serverTransferControllerRef.current = controller;
        setServerTransferFiles(
          largeFiles.map(
            (file, index) => file.name || `${file.provider}-file-${index + 1}`
          )
        );
        setServerTransferBytes(
          largeFiles.reduce((sum, file) => sum + (file.size || 0), 0)
        );

        await Promise.all(
          largeFiles.map(async (file) => {
            const temporaryUuid = uuidv4();
            const mimeType = file.mimeType || '';
            const mediaType = mimeType.startsWith('image/')
              ? 'image'
              : mimeType.startsWith('video/')
              ? 'video'
              : mimeType === 'application/pdf'
              ? 'doc'
              : 'image';

            dispatch(
              addMediaUploadingFiles({
                platform: platform,
                files: [
                  {
                    id: temporaryUuid,
                    uuid: temporaryUuid,
                    name: file.name,
                    file: null,
                    preview_image: file.thumbnailUrl || null,
                    media_type: mediaType,
                    file_type: mimeType,
                    assetBlob: file.thumbnailUrl || null,
                    isUploading: true
                  }
                ]
              })
            );

            try {
              const descriptor = await file.getUploadDescriptor();
              const uploadPreset = await uploadCloudFileViaBackend({
                descriptor,
                name: file.name,
                size: file.size,
                mimeType: file.mimeType,
                width: file.width,
                height: file.height,
                durationMs: file.durationMs,
                locationUuid: location_uuid,
                cloudUuid: cloud_uuid,
                signal: controller.signal
              });

              const previewImage =
                uploadPreset?.uploaded_object_data?.preview_image_url ||
                file.thumbnailUrl ||
                null;

              uploadedLargeFiles.push({
                id: `${uploadPreset?.uuid}`,
                uuid: uploadPreset?.uuid,
                name: file.name,
                file: null,
                preview_image: previewImage,
                media_type: mediaType,
                file_size: file.size,
                uploadPreset,
                file_type: mimeType,
                assetBlob: previewImage,
                source_media_uuid: null,
                uploaded: true,
                isUploading: false,
                editorUpdateState: true,
                previewImageURL: previewImage,
                thumbnail_image:
                  uploadPreset?.thumbnail_url || file.thumbnailUrl || null,
                original_asset:
                  uploadPreset?.uploaded_object_data?.original_asset,
                media_alt_description:
                  uploadPreset?.uploaded_object_data?.media_alt_description,
                api_url: uploadPreset?.uploaded_object_data?.api_url,
                saved_in_media_library: false,
                temporaryUuid
              });
            } catch (error) {
              // User cancelled the server-to-server transfer — silently drop
              // the placeholder, no error toast.
              if (!controller.signal.aborted) {
                console.error(
                  `Failed to upload ${file.provider} media:`,
                  error
                );
                failedImportTranslationKeys.add(
                  getCloudPickerErrorTranslationKey(file.provider, error)
                );
              }
            } finally {
              dispatch(
                deleteALoadingfile({
                  platform: platform,
                  fileID: temporaryUuid
                })
              );
            }
          })
        );

        serverTransferControllerRef.current = null;
        setServerTransferFiles([]);
        setServerTransferBytes(0);

        if (uploadedLargeFiles.length > 0 && postData) {
          dispatch(
            addMediaFiles({
              platform,
              files: uploadedLargeFiles.map(
                ({ temporaryUuid: _unused, ...media }) => media
              )
            })
          );
        }
      }

      if (failedImportTranslationKeys.size > 0) {
        toast.error(
          `${t(
            failedImportTranslationKeys.values().next().value ||
              'lomavisCreator.additionalOptions.cloudImportFailed'
          )}`,
          {
            duration: 4000,
            position: 'top-right'
          }
        );
      }
    } finally {
      setCloudImportInProgress(false);
      setCloudExportItems([]);
      setServerTransferFiles([]);
      setServerTransferBytes(0);
      serverTransferControllerRef.current = null;
    }
  };

  return (
    <div
      key={`${platform}_media_upload_area`}
      className={platform !== ALL ? 'mb-3' : ''}
    >
      <CloudExportProgressModal
        show={cloudExportItems.length > 0}
        items={cloudExportItems}
      />
      <CloudServerTransferModal
        show={serverTransferFiles.length > 0}
        totalBytes={serverTransferBytes}
        onCancel={handleCancelServerTransfer}
      />
      {platform !== ALL && <CreatorPlatformTitle platform={platform} />}
      <div
        style={{ overflowX: 'hidden', position: 'relative', zIndex: 20 }}
        onDrop={handleDrop}
        onDragOver={(e) => {
          e.preventDefault();
          setDragEnabled(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setDragEnabled(false);
        }}
        className={'rounded bg-secondary bg-opacity-25 user-select-none'}
      >
        {dragEnabled && (
          <div
            onDragLeave={(e) => {
              e.preventDefault();
              setDragEnabled(false);
            }}
            style={{ overflowX: 'hidden', zIndex: 20 }}
            className={
              'bg-secondary bg-opacity-50 px-5 position-absolute h-100 w-100'
            }
          >
            <div
              style={{
                top: '50%',
                transform: 'translateY(-50%)',
                textAlign: 'center',
                position: 'relative',
                zIndex: 1 // Ensure text is on top of the semi-transparent background
              }}
              className="text-dark d-flex flex-column gap-3 w-100 "
            >
              <i
                className="fa-solid fa-cloud-arrow-up"
                style={{
                  color: MAIN_COLOR_CODES[PRIMARY_DARK],
                  fontSize: '3rem'
                }}
              ></i>
              <p
                style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                className="fs-3 fw-bold"
              >
                {t('creator.text.drop_files_here')}
              </p>
            </div>
          </div>
        )}
        <div className="h-20px w-100"></div>
        <div
          style={{ position: 'relative' }}
          className="px-5 d-flex flex-column"
        >
          {' '}
          <div
            style={{ zIndex: 2, position: 'relative' }}
            className={'d-flex flex-row gap-1'}
          >
            {items?.length === 0 ? (
              <div
                style={{ rowGap: '3px' }}
                className="w-100 d-flex flex-column text-muted"
              >
                <div
                  onClick={handleUploadClick}
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: 1
                  }}
                ></div>
                <div className="text-center fw-bold py-1">
                  {t('lomavisCreator.dragAndDrop')}
                </div>
                <div className="text-center d-flex justify-content-center py-1">
                  {t('lomavisCreator.or')}
                </div>

                <div
                  style={{ zIndex: 2 }}
                  className="d-flex flex-row align-items-center justify-content-center gap-2 pt-1 w-100 "
                >
                  <button
                    style={{ minWidth: '35%' }}
                    onClick={handleUploadClick}
                    type="button"
                    className="btn btn-white btn-sm pl-4"
                  >
                    <span>
                      <i className="fa-solid fa-arrow-up-from-bracket"></i>
                    </span>{' '}
                    <span className="text-muted fw-bolder">
                      {t('lomavisCreator.uploadFile')}
                    </span>
                  </button>
                  <div
                    style={{ minWidth: '35%' }}
                    className="btn btn-white btn-sm py-1"
                  >
                    <MediaLibraryPopup
                      platform={platform}
                      imageOnly={
                        templateMode &&
                        OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.imageUploadsOnly
                      }
                      onUnsupportedMedia={() =>
                        setShowTemplateImageOnlyModal(true)
                      }
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-100">
                <div
                  onClick={handleUploadClick}
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: 1
                  }}
                ></div>
                <div
                  style={{
                    zIndex: 2,
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: '100%',
                    overflowY: 'scroll'
                  }}
                >
                  <ReOrderableList
                    name="uniqueGroupName"
                    list={items}
                    orientation={'horizontal'}
                    onListUpdate={(newList) => {
                      setItems(newList);

                      dispatch(
                        reorderMediaFiles({
                          platform: platform,
                          newOrder: newList.map((item) => item?.uuid)
                        })
                      );
                    }}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      width: '100%'
                    }}
                  >
                    {items.map((item, index) => {
                      const content =
                        item?.uploadPreset || item?.uploaded ? (
                          <MediaCard
                            item={item}
                            index={index}
                            source={source}
                            setUploadCount={setCurrentUploadCount}
                            setTotalUploadCount={setTotalUploadCount}
                            platform={platform}
                            cropMode={cropMode}
                            disableAutomaticEditor={
                              templateMode &&
                              OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.disableAutomaticMultiImageEditor &&
                              overlayStillToCome
                            }
                            setAutoImageModToggle={
                              cropMode
                                ? () => {
                                    dispatch(
                                      setModalUiContent({
                                        modal: 'multiMediaEditor',
                                        attribute: 'platform',
                                        value: platform
                                      })
                                    );
                                    dispatch(
                                      setModalUiContent({
                                        modal: 'multiMediaEditor',
                                        attribute: 'toggle',
                                        value: true
                                      })
                                    );
                                  }
                                : () => {}
                            }
                          />
                        ) : (
                          <TempMediaCard
                            key={item?.id}
                            item={item}
                            setUploadCount={setCurrentUploadCount}
                            setTotalUploadCount={setTotalUploadCount}
                          />
                        );

                      return items?.some((obj) => obj?.isUploading === true) ? (
                        <div key={`item-${index}`}>{content}</div>
                      ) : (
                        <ReOrderableItem key={`item-${index}`}>
                          {content}
                        </ReOrderableItem>
                      );
                    })}
                    <div
                      className={
                        'img-thumbnail m-1 h-100px w-100px bg-secondary d-flex justify-content-center align-items-center cursor-pointer'
                      }
                      onClick={handleUploadClick}
                    >
                      <i
                        style={{ fontSize: '32px' }}
                        className="fa-duotone fa-plus-large"
                      ></i>
                    </div>
                  </ReOrderableList>
                </div>
              </div>
            )}
          </div>
          {lomavisCreator?.accessibility_guard &&
          postDataMediaFiles?.some(
            (item) =>
              item.media_type === MEDIA_TYPE_IMAGE &&
              (!item.media_alt_description ||
                item.media_alt_description.trim() === '')
          ) ? (
            <div className="d-flex w-100 justify-content-end py-1">
              <ToolTipWithTrigger
                body={
                  <div className="d-flex flex-column gap-1 ">
                    <div className="fw-bolder">
                      {t('lomavisCreator.mediaAccessTooltip_header')}
                    </div>
                    <div className="text-start">
                      {t('lomavisCreator.mediaAccessTooltip_body')}
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm py-2 px-2"
                      onClick={() => {
                        console.log('platform', platform);
                        dispatch(
                          setModalUiContent({
                            modal: 'mediaAltTags',
                            attribute: 'platform',
                            value: platform
                          })
                        );
                        dispatch(
                          setModalUiContent({
                            modal: 'mediaAltTags',
                            attribute: 'toggle',
                            value: true
                          })
                        );
                      }}
                    >
                      {t('lomavisCreator.mediaAccessTooltip_btn')}
                    </button>
                  </div>
                }
              >
                <i className="fa-duotone fa-solid fa-triangle-exclamation fs-2 text-danger cursor-pointer"></i>
              </ToolTipWithTrigger>
            </div>
          ) : (
            <div className="h-20px w-100"></div>
          )}
          <div className={'d-flex flex-row justify-content-end'}>
            <input
              type="file"
              ref={inputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
              multiple={true}
              accept={
                templateMode &&
                OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.imageUploadsOnly
                  ? MEDIA_UPLOAD_IMAGE_ONLY_MIME_TYPES.join(',')
                  : fileInputAcceptString
              }
              max={4}
            />
          </div>
          {(cloudImportInProgress ||
            postDataMediaFiles?.some((obj) => obj?.isUploading === true)) && (
            <div className="h-20px w-100 my-2">
              {' '}
              <div className="d-flex flex-row align-items-center justify-content-start gap-2 flex-fill">
                <span
                  className="spinner-border spinner-border-sm me-1 fs-4 "
                  role="status"
                  aria-hidden="true"
                  style={{ width: '16px', height: '16px' }}
                ></span>
                {postDataMediaFiles?.some(
                  (obj) => obj?.isUploading === true
                ) && (
                  <div
                    style={{ padding: '2px 4px 2px 4px' }}
                    className="text-muted fw-bolder cursor-pointer"
                    onClick={cancelRequest}
                  >
                    {t('lomavisCreator.buttons.cancel')}
                  </div>
                )}
              </div>{' '}
            </div>
          )}
        </div>
      </div>

      <div className="w-100 d-flex flex-column gap-2 mt-1">
        <div className="d-flex flex-row align-items-start justify-content-end gap-2 w-100 flex-wrap flex-fill">
          <div className="d-flex flex-row align-items-start justify-content-end gap-2 flex-wrap">
            {' '}
            <button
              type="button"
              className="btn btn-white btn-sm pt-1 px-2"
              onClick={handleUploadClick}
            >
              <span>
                <i className="fa-duotone fa-arrow-up-from-bracket"></i>
              </span>{' '}
              <span className="text-muted fw-bolder">
                {t('lomavisCreator.uploadFile')}
              </span>
            </button>
            <MediaLibraryPopup
              platform={platform}
              imageOnly={
                templateMode &&
                OVERLAY_TEMPLATE_CREATOR_BEHAVIOUR.imageUploadsOnly
              }
              onUnsupportedMedia={() =>
                setShowTemplateImageOnlyModal(true)
              }
            />
          </div>

          <button
            type="button"
            className="btn btn-white btn-sm pt-1 px-2"
            style={{}}
            onClick={() => {
              dispatch(
                setModalUiContent({
                  modal: 'mediaAltTags',
                  attribute: 'platform',
                  value: platform
                })
              );
              dispatch(
                setModalUiContent({
                  modal: 'mediaAltTags',
                  attribute: 'toggle',
                  value: true
                })
              );
            }}
          >
            <span>
              <i className="fa-solid fa-tag"></i>
            </span>{' '}
            <span className="text-muted fw-bolder">
              {t('lomavisCreator.altTags')}
            </span>
          </button>

          <OtherOptionsDropdown
            onCloudFilesPicked={handleCloudProviderUpload}
            disabled={cloudImportInProgress}
            allowVideoAndPdf={!overlay_enabled && !templateMode}
          />

          <OverlayTrigger
            placement="top"
            delay={{ show: 1000, hide: 0 }}
            overlay={
              <Tooltip>
                <span
                  style={{ display: 'block', textAlign: 'left' }}
                  className="text-muted text-start"
                >
                  {t('lomavisCreator.useSeperateMediaFilesTooltip')}
                </span>
              </Tooltip>
            }
          >
            <div className="d-flex flex-row align-items-start justify-content-end gap-2 mt-1">
              <i
                className={`fa-duotone fa-crop`}
                style={{
                  color: cropMode ? '#0d6efd' : '#6c757d',
                  fontSize: '1.25rem' // 'lg' size corresponds to approximately 1.25rem
                }}
              ></i>
              <Form.Check
                type="switch"
                id="use-seperate-media-files-switch"
                className="cursor-pointer"
                checked={cropMode}
                onChange={() => setCropMode((prevState) => !prevState)}
              />
            </div>
          </OverlayTrigger>
        </div>

        {currentUploadCount === totalUploadCount &&
          isThumbnailValid &&
          !layeredImageThumbnail && (
            <div
              style={{ minWidth: '35%' }}
              className="d-flex align-items-start flex-fill w-100 "
            >
              {layeredThumbnail?.media?.original_asset ? (
                <div className="text-muted ps-5 d-flex flex-column ">
                  {t('lomavisCreator.selectThumbnail')}
                  <div className="d-inline-block">
                    <ThumbnailPreviewCard platform={platform} />
                  </div>
                </div>
              ) : (
                <ThumbnailDropDown platform={platform} />
              )}
            </div>
          )}
      </div>
      <ConfirmationModal
        show={showTemplateImageOnlyModal}
        title={t(
          'lomavisCreator.overlayEditor.imagesOnly.title',
          'Overlays only support images'
        )}
        body={t(
          'lomavisCreator.overlayEditor.imagesOnly.body',
          'This overlay can only be used with images. If you continue without the overlay, the creator will reload and your current progress will be lost.'
        )}
        primaryText={t(
          'lomavisCreator.overlayEditor.imagesOnly.continueWithoutTemplate',
          'Continue without overlay'
        )}
        secondaryText={t('common.ok', 'OK')}
        primaryVariant="danger"
        primaryDisabled={leavingTemplateMode}
        secondaryDisabled={leavingTemplateMode}
        handleClose={() => {
          if (!leavingTemplateMode) {
            setPendingTemplateDragFiles([]);
            setShowTemplateImageOnlyModal(false);
          }
        }}
        handleSecondary={confirmTemplateDraggedFiles}
        handlePrimary={() => {
          setPendingTemplateDragFiles([]);
          continueWithoutTemplate().catch(() => {
            setLeavingTemplateMode(false);
            toast.error(
              t(
                'lomavisCreator.overlayEditor.imagesOnly.leaveFailed',
                'Could not leave the overlay editor. Please try again.'
              ),
              { position: 'top-right' }
            );
          });
        }}
      />
    </div>
  );
};

export default MediaUploadBox;
